import { AxiosError } from 'axios';
import api from '../../../services/api';
import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { useForm, SubmitHandler } from 'react-hook-form';
import InputLabel from '../../../rxlib/components/input-label';
import Redirecionar from '../../../rxlib/components/redirecionar';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import { ModalPrimary } from '../../../rxlib/components/modal/modal-primary';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { SelectLabelAsync } from '../../../rxlib/components/select/select-label-async';
import { ApiError, ProdutoUsuario, ProdutoUsuarioCadastroProps } from '../../../services/tipos';

function ProdutoUsuarioCadastro(props: ProdutoUsuarioCadastroProps) {
    const [salvo, setSalvo] = useState<boolean>(false);
    const [nomeUsuario, setNomeUsuario] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [showPrimary, setShowPrimary] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [messagePrimary, setMessagePrimary] = useState<string[]>([]);

    const [produtoUsuario, setProdutoUsuario] = useState<ProdutoUsuario>({
        id: '',
        idProduto: '',
        idUsuario: '',
    });

    const { register, handleSubmit } = useForm<ProdutoUsuario>();

    const handleHideWarning = () => setShowWarning(false);

    const handleHidePrimary = () => {
        setShowPrimary(false);
        setSalvo(true);
    }

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Usuários', link: '/usuario' },
        { texto: 'Produtos dos usuários', link: `/usuario/produto/${props.match.params.idUsuario}` },
        { texto: props.match.params.action ? 'Visualização' : props.match.params.id ? 'Edição' : 'Novo', link: '' },
    ];

    const temPermissao = props.match.params.action
        ? usuarioTemPermissao(token, 'produto_usuario_visualizar')
        : props.match.params.id
            ? usuarioTemPermissao(token, 'produto_usuario_editar')
            : usuarioTemPermissao(token, 'produto_usuario_novo');

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.id) {
                api.get(`/ProdutoUsuario/${props.match.params.id}`)
                    .then(response => {
                        setProdutoUsuario({
                            id: response.data.id,
                            idProduto: response.data.idProduto,
                            idUsuario: response.data.idUsuario,
                        });
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error);
                    });
            }

            api.get(`/Usuario/${props.match.params.idUsuario}`)
                .then(response => {
                    setNomeUsuario(response.data.nome);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    }, [props.match.params.id, props.match.params.idUsuario, temPermissao]);

    const onSubmit: SubmitHandler<ProdutoUsuario> = data => {
        setCarregando(true);
        props.match.params.id
            ? editar(data)
            : salvar(data);
    }

    function salvar(data: ProdutoUsuario) {
        api.post('/ProdutoUsuario', data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    function editar(data: ProdutoUsuario) {
        api.put('/ProdutoUsuario', data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    function informarSucesso() {
        setMessagePrimary(['Produto do usuário salvo com sucesso.']);
        setShowPrimary(true);
    }

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, 'Não foi possível salvar o produto do usuário: '));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{props.match.params.action ? 'Visualizar' : props.match.params.id ? 'Editar' : 'Novo'} produto do usuário</h6>
                            </div>
                        </div>
                        {
                            props.match.params.id
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            name='id'
                                            type='text'
                                            id='inputId'
                                            maxLength={50}
                                            readOnly={true}
                                            label='Código:'
                                            autoFocus={false}
                                            defaultValue={produtoUsuario.id}
                                            referencia={register({ required: true })}
                                            placeholder='Código do produto do usuário' />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1 d-none'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    name='idUsuario'
                                    autoFocus={false}
                                    id='inputIdUsuario'
                                    label='Código do usuário:'
                                    placeholder='Código do usuário'
                                    referencia={register({ required: true })}
                                    defaultValue={props.match.params.idUsuario} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    name='usuario'
                                    readOnly={true}
                                    id='inputEmail'
                                    label='Usuário:'
                                    autoFocus={false}
                                    placeholder='Usuário'
                                    defaultValue={nomeUsuario}
                                    referencia={React.createRef()} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <SelectLabelAsync
                                    foco='nao'
                                    type='Produto'
                                    name='idProduto'
                                    label='Produto:'
                                    id='inputIdProduto'
                                    action={props.match.params.action}
                                    referencia={register({ required: true })}
                                    valorSelecionado={produtoUsuario.idProduto} />
                            </div>
                        </div>
                        <ButtonsCrud
                            carregando={carregando}
                            styleButton='btn-rxlib'
                            visualizar={props.match.params.action === 'view'}
                            linkCancelarVoltar={`/usuario/produto/${props.match.params.idUsuario}`} />
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <ModalPrimary
                    show={showPrimary}
                    message={messagePrimary}
                    onHide={handleHidePrimary} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <Redirecionar
                    se={salvo}
                    para={`/usuario/produto/${props.match.params.idUsuario}`} />
            </RxlibLayout>
        </>
    );
}

export default ProdutoUsuarioCadastro;